import { Redirect } from 'expo-router'

export default function LegacyTabsForms() {
  return <Redirect href="/forms" />
}
